import push from '../../utils/routing';

export default (spaceId, queryParams) => () => {
  let basePath = `/dashboard/${spaceId}/people/groups`;
  const isMobileScreen = window.matchMedia('(max-width: 899px)').matches;
  if (isMobileScreen) {
    basePath = `${basePath}/group-sets`;
  }

  if (!queryParams) {
    push(basePath);
    return;
  }

  const params = new URLSearchParams(
    Object.entries(queryParams).filter(([, value]) => value != null)
  );
  // Append query parameters only if there are any in path
  const updatedPath = params.toString() ? `${basePath}?${params}` : basePath;
  push(updatedPath);
};
